// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2vQGP","footer":"ModalUpdate_footer__1zYXV"};